module.exports = __webpack_public_path__ + "assets/favicons/android-chrome-192x192.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=assets/favicons/[name].[ext]!./src/assets/favicons/android-chrome-192x192.png
// module id = YAI9
// module chunks = 1